import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import './Langs.css'
import template from './Langs.jinja'

var Langs = Backbone.View.extend({
    el: '.Langs',

    SHIFT: 15,

    initialize () {
        app.vent.on('langs.activate', this.activate)

        this.$links = this.$('.Langs-link')
    },

    activate(options) {
        if (options && options.fixed) {
            this.$el[0].style.position = 'fixed'
        }

        _.each(this.$links, (item, index) => {
            let index1 = index + 1
            $.Velocity.hook(item, 'translateY', (this.SHIFT * (Math.pow(-1, index1 % 2)) + 'px'))
        })
        $.Velocity.hook(this.$el[0], 'opacity', 0)
        this.$el[0].style.display = 'block'

        this.$el.velocity('stop', true)
        this.$links.velocity('stop', true)

        $.Velocity.animate(this.$el, {
            opacity: [1, 'linear']
        }, _.extend({duration: 400}, options))

        return $.Velocity.animate(this.$links, {
            translateY: [0, 'easeOutQuant']
        }, _.extend({duration: 400}, options))
    },

    deactivate(options) {
        var promise

        _.each(this.$links, (item) => {
            $.Velocity.hook(item, 'translateY', '0px')
        })
        $.Velocity.hook(this.$el, 'opacity', 1)

        this.$el.velocity('stop', true)
        this.$links.velocity('stop', true)

        $.Velocity.animate(this.$el, {
            opacity: [0, 'linear']
        }, _.extend({
            display: 'none',
            duration: 500
        }, options))

        _.each(this.$links, (item, index) => {
            let index1 = index + 1
            promise = $.Velocity.animate(item, {
                translateY: [(this.SHIFT * (Math.pow(-1, index1 % 2)) + 'px'), 'easeOutQuant']
            }, _.extend({duration: 400}, options))
        })

        return promise
    }
})

export default Langs


// WEBPACK FOOTER //
// ./assets/app/front/components/Langs/Langs.js